import React from 'react';
import HelpWalkthrough from '../shared/HelpWalkthrough';

// "How products work" walkthrough, opened from the `?` in the Products header.

const GlobeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" />
  </svg>
);
const StoreIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M4 9.5 5.2 4h13.6L20 9.5M4 9.5h16M4 9.5v9.5a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.5M4 9.5a2.2 2.2 0 0 0 4 0 2.2 2.2 0 0 0 4 0 2.2 2.2 0 0 0 4 0 2.2 2.2 0 0 0 4 0M9.5 20v-5h5v5" />
  </svg>
);
const BoxesIcon = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 7.5 12 3l9 4.5-9 4.5-9-4.5Z" /><path d="M3 7.5V16l9 4.5 9-4.5V7.5M12 12v8.5" />
  </svg>
);

const ChannelsStage = () => (
  <div className="hw-ill">
    <div className="hw-ill-tile"><span className="hw-ill-badge"><GlobeIcon /></span><span className="hw-ill-label" style={{ color: '#29282D', fontWeight: 700 }}>Online</span></div>
    <div className="hw-ill-tile"><span className="hw-ill-badge hw-ill-badge--charcoal"><StoreIcon /></span><span className="hw-ill-label" style={{ color: '#29282D', fontWeight: 700 }}>In store</span></div>
  </div>
);

const StockStage = () => (
  <div className="hw-ill" style={{ flexDirection: 'column', gap: 16 }}>
    <span className="hw-ill-badge hw-ill-badge--amber"><BoxesIcon /></span>
    <span style={{ display: 'inline-flex', gap: 7 }}>
      {[{ l: 'In stock', c: '#E5F5EF', t: '#1FA97A' }, { l: 'Low', c: '#FBF1DE', t: '#B5841F' }].map((s) => (
        <span key={s.l} style={{ fontSize: 11.5, fontWeight: 700, color: s.t, background: s.c, borderRadius: 999, padding: '4px 11px' }}>{s.l}</span>
      ))}
    </span>
  </div>
);

const SLIDES = [
  {
    key: 'channels',
    title: 'Sell online and in store',
    body: 'List a product to sell it on your online shop and at the till. Switch online selling on or off per product, so you choose exactly what clients can buy between visits.',
    Stage: ChannelsStage,
  },
  {
    key: 'stock',
    title: 'Track stock with Stock Take',
    body: 'Add stock and keep levels accurate through Stock Take. Count what you have, adjust as you go, and spot what is running low before it sells out.',
    Stage: StockStage,
  },
];

const ProductHelp = ({ onClose }) => (
  <HelpWalkthrough eyebrow="How products work" slides={SLIDES} onClose={onClose} />
);

export default ProductHelp;
